<div>
  <div class="msg">
    <p class="msg-text">{{message}}</p>
    <div class="pos-btn">
      <button class="btn" *ngIf="data.buttonText?.ok" (click)="save()">{{confirmButtonText}}</button>
      <button mat-dialog-close class="btn">{{cancelButtonText}}</button>
    </div>
  </div>
</div>